module.exports = __webpack_public_path__ + "img/map.4ff4abaa.png";